/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
/* eslint-disable arrow-body-style */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */

import React, { useEffect, useState } from 'react';
import {
    Button,
    Drawer, Form, Input, Modal, Tooltip,
} from 'antd';
import Slider from 'react-slick';
import '../ProjectList/slider.less';
import { useHistory } from 'react-router-dom';
import useForm from 'antd/lib/form/hooks/useForm';
import { inject, observer } from 'mobx-react';
import Routes from '../../Global/Routes';
import utility from '../../Global/Utility';
import { Project } from '../../Global/interface';
import categoryStore from '../../Store/categoryStore';
import rules from '../ProjectList/userDetails.validation';
import contactService from '../../Services/contactService';
import { Toast } from '../../Components';

function Projects() {
    const history = useHistory();
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isPdfModalOpen, setIsPdfModalOpen] = useState<boolean>(false);
    const [form] = useForm();

    useEffect(() => {
        if (JSON.parse(JSON.stringify(categoryStore?.categories)).length === 0) {
            history.push(Routes.ourWork);
        }
    }, []);

    const redirectToProjectDetail = (selectedProject: Project) => {
        categoryStore.setProject(selectedProject);
        history.push(Routes.project);
    };

    const isSingleItem = categoryStore.category?.projects.length === 1;

    const sendUserReq = async (values: any) => {
        await contactService.createUserDetails(values)
            .then(() => {
                setIsModalOpen(false);
                form.resetFields();
                openPdfModal();
            })
            .catch((error: any) => Toast.error(error));
    };

    const handleDownloadPDF = () => {
        utility.downloadPdf();
        setIsPdfModalOpen(false);
    };

    const pdfModal = () => {
        return (
            <Modal
                title="Download PDF"
                visible={isPdfModalOpen}
                onOk={handleDownloadPDF}
                onCancel={closePdfModal}
                okText="Download"
                cancelText="Cancel"
            >
                <p>Please click the below <span style={{ fontWeight: 'bold', color: 'black' }}>Download</span> button to download the file.</p>
            </Modal>
        );
    };

    const showDrawer = () => {
        setIsModalOpen(true);
    };

    const closeDrawer = () => {
        form.resetFields();
        setIsModalOpen(false);
    };

    const openPdfModal = () => {
        setIsPdfModalOpen(true);
    };

    const closePdfModal = () => {
        setIsPdfModalOpen(false);
    };

    const onFormSubmit = () => {
        form.validateFields()
            .then((values) => {
                sendUserReq(values);
            }).catch(() => { });
    };

    function categorySlider() {
        const settings = {
            dots: true,
            infinite: !isSingleItem, // Disable infinite scrolling if only one item
            speed: 500,
            slidesToShow: isSingleItem ? 1 : (categoryStore.category && categoryStore.category.projects.length > 3) ? 3 : categoryStore.category?.projects.length, // Show only 1 slide if single item
            slidesToScroll: isSingleItem ? 1 : (categoryStore.category && categoryStore.category.projects.length > 3) ? 3 : categoryStore.category?.projects.length,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: isSingleItem ? 1 : (categoryStore.category && categoryStore.category.projects.length > 3) ? 3 : categoryStore.category?.projects.length,
                        slidesToScroll: isSingleItem ? 1 : (categoryStore.category && categoryStore.category.projects.length > 3) ? 3 : categoryStore.category?.projects.length,
                        infinite: true,
                        dots: true,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        };
        return (
            <div style={{ width: isSingleItem ? '300px' : '100%', margin: '0 auto' }}>
                <Slider {...settings}>
                    {categoryStore.category?.projects && categoryStore.category?.projects.map((project: Project) => {
                        return (
                            <div key={project._id}>
                                <Tooltip placement="leftTop" title={project.name}>
                                    <h3 className="project-header">{project.name}</h3>
                                </Tooltip>
                                <div className="kud-slider-image">
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            redirectToProjectDetail(project);
                                        }}
                                    >
                                        <img src={project?.images[0]?.fileUrl} alt="doc_close" />
                                    </a>
                                </div>
                            </div>
                        );
                    })}
                </Slider>
            </div>

        );
    }

    return (
        <div className="kud-centered">
            <div className="slider-container mt-1">
                {categorySlider()}
            </div>
            <div className="mt-4"><Button className="border-0 border-radius primary r-bold" onClick={showDrawer}> Download Portfolio</Button></div>
            <Drawer className="apply-modal" title="Download Portfolio" placement="bottom" onClose={closeDrawer} visible={isModalOpen}>
                <div className="modal-inner-download-portfolio">
                    <Form
                        layout="vertical"
                        onFinish={onFormSubmit}
                        form={form}
                        validateTrigger={['onBlur', 'onSubmit', 'onChange']}
                        scrollToFirstError
                    >
                        <Form.Item label="Full Name" name="full_name" rules={rules.full_name} normalize={utility.trimSpacesInValues}>
                            <Input placeholder="Enter your name" maxLength={50} />
                        </Form.Item>
                        <Form.Item label="Email" name="email" rules={rules.email} normalize={utility.trimSpacesInValues}>
                            <Input placeholder="Enter your email" maxLength={50} />
                        </Form.Item>
                        <Form.Item label="Phone" name="phone" rules={rules.phone} normalize={utility.trimSpacesInValues}>
                            <Input placeholder="Enter your phone number" maxLength={20} />
                        </Form.Item>
                        <Form.Item>
                            <Button htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Drawer>
            {pdfModal()}
        </div>
    );
}

export default inject('categoryStore')(observer(Projects));
